module.exports = __webpack_public_path__ + "static/43335594acd208703ddb42fbcc12e77b.svg";